<template>
  <CardIcon
    :icon="icon"
    squareBackground
  >
    <HeadingMedium>
      {{ title }}
    </HeadingMedium>
    <ParagraphBody v-if="instructions">
      {{ instructions }}
    </ParagraphBody>
    <slot />
  </CardIcon>
</template>

<script>
import {
  CardIcon, HeadingMedium, ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'CardSettingsIcon',

  components: {
    CardIcon,
    HeadingMedium,
    ParagraphBody,
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    instructions: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      required: true,
    },
  },
};
</script>
